/* eslint-disable unicorn/no-thenable */

import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class Shopify extends Service<ShopifyDto> {
  static Schema = z.object({
    apiKey: z.string().default(''),
    apiPassword: z.string().default(''),
    locationId: z.string().default(''),
    webhookSecret: z.string().min(1),
  });

  apiKey = '';
  apiPassword = '';
  locationId = '';
  webhookSecret = '';

  constructor(dto: ShopifyDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      apiKey: observable,
      apiPassword: observable,
      locationId: observable,
      webhookSecret: observable,
    });

    Object.assign(this, dto);
  }

  toJSON(): RequireAllProps<ShopifyDto> {
    return {
      ...super.toJSON(),
      apiKey: this.apiKey,
      apiPassword: this.apiPassword,
      locationId: this.locationId,
      webhookSecret: this.webhookSecret,
    };
  }
}

export interface ShopifyDto extends ServiceDto {
  apiKey?: string;
  apiPassword?: string;
  locationId?: string;
  webhookSecret?: string;
}
